import { client } from './epic'


export const variation = (feature) => {
  return client && client.getTreatment(feature)
}



// WEBPACK FOOTER //
// ./src/modules/experiment/helpers.js